import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { components } from '../../components';
import dateHelper from '../../helpers/dateHelper';
import { hooks } from '../../hooks';
import { Routes } from '../../routes';
import apiService from "../../service/ApiService";
import { RootState } from '../../store';
import { MenuType } from '../../types';
import utils from '../../helpers/utils';

export const Menu: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();

  const [categories, setCategories] = useState<[]>([]);
  const [opacity, setOpacity] = useState<number>(0);
  const [categoryLoading, setCategoryLoading] = useState<boolean>(true);

  const authState = useSelector((state: RootState) => state.authReducer.auth);
  const orderMode = useSelector((state: RootState) => state.appReducer.orderMode);
  const selectedSiteId = useSelector((state: RootState) => state.selectedSiteReducer.selectedSiteId);


  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);


  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    const { data } = await apiService.getCategoriesAsync(selectedSiteId, orderMode);
    if (data) {
      let categories = data.filter((category: { openingTime: any; closingTime: any; isPrivate: any; }) => {
        const isWithinTime = (!category.openingTime || !category.closingTime) || dateHelper.isCurrentTimeWithinRange(category.openingTime, category.closingTime);
        const isAccessible = authState && authState.user && !authState.user.isGuest ? true : !category.isPrivate;
        return isWithinTime && isAccessible;
      });
      setCategories(categories);
    }
    setCategoryLoading(false);
  };

  const renderMenu = (): JSX.Element => {
    return (
      <section style={{ paddingTop: 10, paddingBottom: 10 }}>
        <ul
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 15,
          }}
        >
          {categories.map((menu: any, index: number, array: MenuType[]) => {
            return (
              <li
                key={index}
                className='clickable'
                style={{
                  position: 'relative',
                  backgroundColor: "var(--white-color)",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 10,
                  overflow: 'hidden',
                }}
                onClick={() =>
                  navigate(Routes.MenuList, { state: { category: menu } })
                }
              >
                <img
                  src={utils.getImagePath(menu.imagePath)}
                  alt={menu.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: '10px 0',
                    backgroundColor: 'var(--input-background)',
                    borderRadius: '0 0 10px 10px',
                  }}
                >
                  <span
                    className='t16 number-of-lines-1'
                    style={{ color: 'var(--main-color)' }}
                  >
                    {menu.name}
                  </span>
                </div>
              </li>
            )
          })}
        </ul>
      </section>
    );
  };
  const renderContent = (): JSX.Element | null => {
    if (categoryLoading && !categories.length) return null;
    return <main className='scrollable container'>{renderMenu()}</main>;
  };

  const renderLoader = (): JSX.Element | null => {
    if (categoryLoading) return <components.Loader />;
    return null;
  };

  return (
    <div
      id='screen'
      style={{ opacity }}
    >
      {renderLoader()}
      {renderContent()}
    </div>
  );
};
